class CustomAccordion {
  constructor(node) {
    this.accordion = node;
    this.trigger = node.querySelector("[data-accordion-trigger]");
    this.content = node.querySelector("[data-accordion-content]");

    if (this.trigger && this.content) {
      this.trigger.addEventListener("click", () => this.toggleAccordion());
      if (this.trigger.getAttribute("aria-expanded") === "true") {
        this.content.style.height = `${this.content.scrollHeight}px`;
      }
    }
  }

  toggleAccordion() {
    const isExpanded = this.trigger.getAttribute("aria-expanded") === "true";
    this.trigger.setAttribute("aria-expanded", !isExpanded);

    if (!isExpanded) {
      this.content.style.height = `${this.content.scrollHeight}px`;
    } else {
      this.content.style.height = "0";
    }
  }
}

// Initialize custom accordions
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-accordion]").forEach((accordion) => {
    new CustomAccordion(accordion);
  });
});

// Re-initialize on section load
document.addEventListener("shopify:section:load", (event) => {
  event.target.querySelectorAll("[data-accordion]").forEach((accordion) => {
    new CustomAccordion(accordion);
  });
});
